export default function (): void {
  const el = document.querySelector('.cms-snippet')

  if (!el) {
    return
  }

  el.querySelectorAll<HTMLButtonElement>('button').forEach((buttonEl) => {
    buttonEl.addEventListener('click', () => {
      if (buttonEl.getAttribute('data-view') === 'more') {
        el.setAttribute('data-expanded', 'true')
      }

      if (buttonEl.getAttribute('data-view') === 'less') {
        el.setAttribute('data-expanded', 'false')
        el.scrollIntoView()
      }
    })
  })
}
